import React, { useState } from 'react';

import { notYetEventData } from '../../types/Reigenspf001';
import { dateFormatter } from './dateFormatter';

/**
 * 未申し込みのイベントを表示するコンポーネント
 * @param props イベント情報
 * @returns
 */
export function NotYetEvent (props: notYetEventData) {
  //  時間のフォーマット変更
  //  申込期限日時
  const eventLimitTime = formatTime(props.limit_time)

  //  開催日時（開始）
  const eventFromTime= formatTime(props.from_time)

  //  開催日時（終了）
  const eventToTime = formatTime(props.to_time)


  /**
   * 
   * @param date string型の時刻(hh:mm:ss)
   * @returns results [hh,mm,ss]
   */
  function formatTime(date: string){
    const result = date.split(':');

    return result
  }


  return(
    <>
      <div className="l-record">
        <div className="record-list">
          <div className="record-title-box">
            <h3 className="title">
              <a href={`/edit?url=${props.url}`} className="link-ic">
                <i className={props.icon_class}></i>
                <span className="txt">{props.subject}</span>
              </a>
            </h3>
          </div>
          <div className="record-set col1">
            <dl>
              <dt>申込期限</dt>
              <dd>{dateFormatter(props.limit_date.toString())} {eventLimitTime[0]}:{eventLimitTime[1]}まで</dd>
            </dl>
          </div>
          <div className="record-set col1">
            <dl>
              <dt>開催日</dt>
              <dd>{dateFormatter(props.date.toString())}</dd>
            </dl>
          </div>
          <div className="record-set col1">
            <dl>
              <dt>開催日時</dt>
              <dd>{eventFromTime[0]}:{eventFromTime[1]}～{eventToTime[0]}:{eventToTime[1]}</dd>
            </dl>
          </div>
          <div className="record-set col1">
            <dl>
              <dt>会場名</dt>
              <dd>{props.location}</dd>
            </dl>
          </div>
          <div className="record-set col1">
            <dl>
              <dt>主管部署</dt>
              <dd>{props.department_name}</dd>
            </dl>
          </div>
          <div className="record-set col1">
            <dl>
              <dt>会費</dt>
              <dd>{props.member_fee.toLocaleString()}円</dd>
            </dl>
          </div>
        </div>
      </div>
    </>
  );
}

